import { ITypeSelectCustom } from '@/shared/constants/IContants'
import { isArray } from '@/shared/function'
import { i18n } from '@/shared/i18n'
import { ValueCheckbox } from '../enums'

function generateValueCheckbox(
    listCheckbox: ITypeSelectCustom[],
    listValue: number[],
    keyValue: string,
    isCheckAll = false
) {
    const keyName = keyValue + '_name'
    if (isCheckAll && listValue.length === listCheckbox.length) {
        return {
            [keyName]: [
                i18n.t('i18n_select_all_checkbox_service_office_advisor')
            ],
            [keyValue]: [ValueCheckbox.ALL]
        }
    }

    return listCheckbox.reduce(
        (preVal: any, nextVal: ITypeSelectCustom) => {
            const { label, value } = nextVal

            if (isArray(listValue) && listValue.includes(value)) {
                preVal[keyValue] = preVal[keyValue].concat(value)
                preVal[keyName] = preVal[keyName].concat(label)
            }

            return preVal
        },
        {
            [keyName]: [],
            [keyValue]: []
        }
    )
}

export { generateValueCheckbox }
